import { Routes } from '@angular/router';
import { AuthGuard } from './auth-guard';
import { GestionComptesComponent } from './gestion-comptes/gestion-comptes.component';
import { DemandesComponent } from './gestion-comptes/demandes/demandes.component';
import { UtilisateursComponent } from './gestion-comptes/utilisateurs/utilisateurs.component';
import { FournisseursComponent } from './fournisseurs/fournisseurs.component';
import { FournisseursUserComponent } from './fournisseurs/components/fournisseurs-user/fournisseurs-user.component';
import { AdherentsComponent } from './adherents/adherents.component';
import { AdherentsUserComponent } from './adherents/components/adherents-user/adherents-user.component';
import { PFAInterneComponent } from './pfa-interne/pfa-interne.component';
import { LinkAdherentComponent } from './pfa-interne/components/link-adherent/link-adherent.component';
import { NotFoundComponent } from '@hygie31/ngx-hygie31-kit-ui-17';
import { LegalMentionsComponent } from './legal-mentions/legal-mentions.component';

export const routes: Routes = [
  { path: '', component: FournisseursComponent, canActivate: [AuthGuard] },
  {
    path: 'fournisseurs',
    component: FournisseursComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'fournisseurs/fournisseurs-user',
    component: FournisseursUserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'gestioncomptes',
    component: GestionComptesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'gestioncomptes/demandes',
    component: DemandesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'gestioncomptes/utilisateurs',
    component: UtilisateursComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'adherents',
    component: AdherentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'adherents/adherents-user',
    component: AdherentsUserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pfa-interne',
    component: PFAInterneComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pfa-interne/link-adherents',
    component: LinkAdherentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mentions-legales',
    component: LegalMentionsComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    component: NotFoundComponent,
  },
];
